import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import DayJs from 'utils/Dayjs';
import { EXAM_STUDENT_STATES } from 'utils/Constants';

import Pill from 'components/Misc/Pill';
import { Title, Dates } from 'components/Misc/Typography';

const Exam = ({ take }) => {
	// Check if take is locked
	const locked = useMemo(() => DayJs(take.startDate).isAfter(DayJs()), [take.startDate]);

	const className = classnames(
		'py-2 px-3 flex flex-col space-y-2 md:flex-row md:items-center md:space-y-0 md:space-x-2 border-4 rounded-lg transition-all',
		'dark:border-neutral-800 dark:bg-neutral-800',
		'border-white bg-white',
		!locked && 'hover:bg-neutral-50 hover:dark:bg-neutral-900 cursor-pointer',
		locked && 'opacity-60 cursor-not-allowed'
	);

	// Find type info
	const state = useMemo(() => EXAM_STUDENT_STATES.find(state => state.value === take.state), [take.state]);

	if (locked) {
		return (
			<div className={className}>
				<div className="flex flex-1">
					<Title
						title={take.exam.titlePublic}
						className="flex-1"
					/>

					<Pill
						name={state?.text}
						theme={state?.theme}
					/>
				</div>
	
				<Dates
					startDate={take.startDate}
					endDate={take.endDate}
				/>
			</div>
		);
	}

	return (
		<Link to={`/exams/${take.id}`} className={className}>
			<div className="flex flex-1">
				<Title
					title={take?.exam?.titlePublic}
					className="flex-1 whitespace-nowrap text-ellipsis overflow-hidden"
				/>

				<Pill
					name={state?.text}
					theme={state?.theme}
				/>
			</div>

			<Dates
				startDate={take.startDate}
				endDate={take.endDate}
			/>
		</Link>
	);
};

export default Exam;